export default __webpack_public_path__ + "static/media/main.33a31f48.png";